// extracted by mini-css-extract-plugin
export default {"aside":"ProjectsAside_aside__HMv+t","item":"ProjectsAside_item__M8D3k","link":"ProjectsAside_link__mnzTh","name":"ProjectsAside_name__SRHUM"};